import "./popup.scss";

import React, { useCallback, useEffect, useState } from "react";

import Tooltip from '@mui/material/Tooltip';

import { AutodeskConstants } from "../../autodeskConstants";
import { IAutodeskPopupProps } from "./interfaces/IAutodeskPopupProps";
import { IVector } from "../../interfaces";
import { Point } from "../../models";

export const Popup: React.FC<IAutodeskPopupProps> = (props) => {

    const { viewer } = props;

    const [popupPosition, setPopupPosition] = useState<IVector>(new Point(0, 0));

    const getClientPosition = useCallback((worldVector: IVector): IVector => {
        const canvasRect = viewer.canvas.getBoundingClientRect();

        const vector = Point.ToVector(worldVector);
        const position = viewer.worldToClient(vector);

        position.x += canvasRect.left;
        position.y += canvasRect.top;

        return position;
    }, [viewer])

    useEffect(() => {
        if (!props.content.position) {
            return;
        }
        const clientPosition = getClientPosition(props.content.position);
        setPopupPosition(clientPosition);
    }, [props.content.position, getClientPosition])

    useEffect(() => {
        if (!viewer) {
            return;
        }
        const onCameraChanged = (): void => {
            if (!props.showPopup) {
                return;
            }
            const clientPosition = getClientPosition(props.content.position);
            setPopupPosition(clientPosition);
        };

        viewer.addEventListener(Autodesk.Viewing.CAMERA_CHANGE_EVENT, onCameraChanged);
        return (): void => {
            viewer.removeEventListener(Autodesk.Viewing.CAMERA_CHANGE_EVENT, onCameraChanged);
        }
    }, [viewer, props.showPopup, getClientPosition, props.content.position]);

    const generateGetBoundingClientRect = (x = 0, y = 0): any => {

        let emptyFunction: any;

        return () => ({
            width: 0,
            height: 0,
            top: y,
            right: x,
            bottom: y,
            left: x,
            x: x,
            y: y,
            toJSON: emptyFunction
        });
    }

    return (
        <Tooltip
            title={props.content.content}
            arrow={true}
            placement="top"
            open={props.showPopup}
            PopperProps={{
                container: document.getElementById(AutodeskConstants.Elements.PopupContainerId),
                anchorEl: {
                    getBoundingClientRect: generateGetBoundingClientRect(popupPosition.x, popupPosition.y),
                }
            }}
        >
            <span className="tooltip"></span>
        </Tooltip >
    );
};
